export const codeExamples = {
  'face-detect': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/face-detect', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    image: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
  })
});

const result = await response.json();
// Face detection result: result.faceDetected`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/face-detect"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

with open("image.jpg", "rb") as image_file:
    image_data = base64.b64encode(image_file.read()).decode('utf-8')

data = {
    "image": f"data:image/jpeg;base64,{image_data}"
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Face detected: {result['faceDetected']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/face-detect \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "image": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/face-detect";

$imageData = base64_encode(file_get_contents("image.jpg"));
$data = [
    "image" => "data:image/jpeg;base64," . $imageData
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Face detected: " . ($response['faceDetected'] ? 'true' : 'false');
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/face-detect"
    
    imageData, _ := ioutil.ReadFile("image.jpg")
    encoded := base64.StdEncoding.EncodeToString(imageData)
    
    data := map[string]string{
        "image": "data:image/jpeg;base64," + encoded,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Face detected: %v\\n", result["faceDetected"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> detectFace() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/face-detect';
  
  // Read image file and convert to base64
  final imageFile = File('image.jpg');
  final imageBytes = await imageFile.readAsBytes();
  final base64Image = base64Encode(imageBytes);
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'image': 'data:image/jpeg;base64,$base64Image',
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Face detected: \${result['faceDetected']}');
  }
}`
  },
  'face-detect-batch': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/face-detect-batch', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    images: [
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
    ]
  })
});

const result = await response.json();
// Total faces: result.totalFaces`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/face-detect-batch"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

images = []
for image_path in ["image1.jpg", "image2.jpg"]:
    with open(image_path, "rb") as image_file:
        image_data = base64.b64encode(image_file.read()).decode('utf-8')
        images.append(f"data:image/jpeg;base64,{image_data}")

data = {"images": images}
response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Total faces: {result['totalFaces']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/face-detect-batch \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "images": [
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
    ]
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/face-detect-batch";

$images = [];
foreach (["image1.jpg", "image2.jpg"] as $imagePath) {
    $imageData = base64_encode(file_get_contents($imagePath));
    $images[] = "data:image/jpeg;base64," . $imageData;
}

$data = ["images" => $images];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Total faces: " . $response['totalFaces'];
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/face-detect-batch"
    
    var images []string
    for _, imagePath := range []string{"image1.jpg", "image2.jpg"} {
        imageData, _ := os.ReadFile(imagePath)
        encoded := base64.StdEncoding.EncodeToString(imageData)
        images = append(images, "data:image/jpeg;base64," + encoded)
    }
    
    data := map[string]interface{}{
        "images": images,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Total faces: %v\\n", result["totalFaces"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> detectFacesBatch() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/face-detect-batch';
  
  // Read multiple image files and convert to base64
  final imagePaths = ['image1.jpg', 'image2.jpg'];
  final List<String> images = [];
  
  for (final imagePath in imagePaths) {
    final imageFile = File(imagePath);
    final imageBytes = await imageFile.readAsBytes();
    final base64Image = base64Encode(imageBytes);
    images.add('data:image/jpeg;base64,$base64Image');
  }
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'images': images,
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Total faces: \${result['totalFaces']}');
  }
}`
  },
  'ai-image-detect': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/ai-image-detect', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    image: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
  })
});

const result = await response.json();
// AI detection: result.aiGenerated, score: result.aiGeneratedScore`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/ai-image-detect"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

with open("image.jpg", "rb") as image_file:
    image_data = base64.b64encode(image_file.read()).decode('utf-8')

data = {
    "image": f"data:image/jpeg;base64,{image_data}"
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"AI Generated: {result['aiGenerated']}")
print(f"AI Score: {result['aiGeneratedScore']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/ai-image-detect \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "image": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/ai-image-detect";

$imageData = base64_encode(file_get_contents("image.jpg"));
$data = [
    "image" => "data:image/jpeg;base64," . $imageData
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "AI Generated: " . ($response['aiGenerated'] ? 'true' : 'false');
echo "AI Score: " . $response['aiGeneratedScore'];
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/ai-image-detect"
    
    imageData, _ := os.ReadFile("image.jpg")
    encoded := base64.StdEncoding.EncodeToString(imageData)
    
    data := map[string]string{
        "image": "data:image/jpeg;base64," + encoded,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("AI Generated: %v\\n", result["aiGenerated"])
    fmt.Printf("AI Score: %v\\n", result["aiGeneratedScore"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> detectAI() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/ai-image-detect';
  
  // Read image file and convert to base64
  final imageFile = File('image.jpg');
  final imageBytes = await imageFile.readAsBytes();
  final base64Image = base64Encode(imageBytes);
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'image': 'data:image/jpeg;base64,$base64Image',
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('AI Generated: \${result['aiGenerated']}');
    print('AI Score: \${result['aiGeneratedScore']}');
  }
}`
  },
  'composite-check': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/composite-check', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    image: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
    face_detect: true,
    ai_image_detect: false
  })
});

const result = await response.json();
// Face detection: result.results.face_detect
// AI detection: result.results.ai_image_detect`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/composite-check"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

with open("image.jpg", "rb") as image_file:
    image_data = base64.b64encode(image_file.read()).decode('utf-8')

data = {
    "image": f"data:image/jpeg;base64,{image_data}",
    "face_detect": True,
    "ai_image_detect": False
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Face detection: {result['results']['face_detect']}")
print(f"AI detection: {result['results']['ai_image_detect']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/composite-check \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "image": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
    "face_detect": true,
    "ai_image_detect": false
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/composite-check";

$imageData = base64_encode(file_get_contents("image.jpg"));
$data = [
    "image" => "data:image/jpeg;base64," . $imageData,
    "face_detect" => true,
    "ai_image_detect" => false
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Face detection: " . json_encode($response['results']['face_detect']);
echo "AI detection: " . json_encode($response['results']['ai_image_detect']);
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/composite-check"
    
    imageData, _ := os.ReadFile("image.jpg")
    encoded := base64.StdEncoding.EncodeToString(imageData)
    
    data := map[string]interface{}{
        "image": "data:image/jpeg;base64," + encoded,
        "face_detect": true,
        "ai_image_detect": false,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Face detection: %v\\n", result["results"].(map[string]interface{})["face_detect"])
    fmt.Printf("AI detection: %v\\n", result["results"].(map[string]interface{})["ai_image_detect"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> compositeCheck() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/composite-check';
  
  // Read image file and convert to base64
  final imageFile = File('image.jpg');
  final imageBytes = await imageFile.readAsBytes();
  final base64Image = base64Encode(imageBytes);
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'image': 'data:image/jpeg;base64,$base64Image',
      'face_detect': true,
      'ai_image_detect': false,
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Face detection: \${result['results']['face_detect']}');
    print('AI detection: \${result['results']['ai_image_detect']}');
  }
}`
  },
  'trust-score': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/trust-score', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    user_id: 'abc123',

    // 1️⃣ Images
    images: [
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
    ],

    // Optional config
    // Global config is all true by default if not set otherwise
    global_configuration: { face_detect: true, ai_image_detect: false },
    // All images are global config by default, but specific configs can be set for images
    per_image_configuration: {
      "0": { ai_image_detect: false }, // disable for first image
      "3": { face_detect: false, ai_image_detect: false } // disable for fourth image
    },

    // 2️⃣ Bio
    bio: "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",

    // 3️⃣ Prompts — flexible list
    prompts: [
      {
        question: "My ideal weekend",
        answer: "A mix of nature and good food 🍜🌲"
      },
      {
        question: "The key to my heart is",
        answer: "Honesty and humor."
      }
    ],

    // 4️⃣ Metadata — free-form text
    metadata: \`
      IP=192.168.0.3
      device=Android
      region=CA
      num_photos=2
      referred_by=friend
    \`,
   // Overrides text analysis and outputs 0 if any of the image checks fail. False by default when not specified
   image_block: true
  })
});

const result = await response.json();
// Trust Score: result.trust_score (0-100)
// Image Results: result.image_results
// Text Results: result.text_results`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/trust-score"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

# Prepare images
images = []
for image_path in ["image1.jpg", "image2.jpg"]:
    with open(image_path, "rb") as image_file:
        image_data = base64.b64encode(image_file.read()).decode('utf-8')
        images.append(f"data:image/jpeg;base64,{image_data}")

data = {
    "user_id": "abc123",
    "images": images,
    # Optional: Global config (defaults to both True)
    "global_configuration": {"face_detect": True, "ai_image_detect": False},
    # Optional: Per-image overrides
    "per_image_configuration": {
        "0": {"ai_image_detect": False},
        "3": {"face_detect": False, "ai_image_detect": False}
    },
    # Optional: Bio
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    # Optional: Prompts
    "prompts": [
        {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
        {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    # Optional: Metadata
    "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend",
    # Optional: Image block (defaults to False)
    "image_block": True
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Trust Score: {result['trust_score']}")
print(f"Image Results: {result['image_results']}")
print(f"Text Results: {result['text_results']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/trust-score \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": "abc123",
    "images": [
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
    ],
    "global_configuration": {"face_detect": true, "ai_image_detect": false},
    "per_image_configuration": {
      "0": {"ai_image_detect": false},
      "3": {"face_detect": false, "ai_image_detect": false}
    },
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts": [
      {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
      {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend",
    "image_block": true
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/trust-score";

// Prepare images
$images = [];
foreach (["image1.jpg", "image2.jpg"] as $imagePath) {
    $imageData = base64_encode(file_get_contents($imagePath));
    $images[] = "data:image/jpeg;base64," . $imageData;
}

$data = [
    "user_id" => "abc123",
    "images" => $images,
    "global_configuration" => ["face_detect" => true, "ai_image_detect" => false],
    "per_image_configuration" => [
        "0" => ["ai_image_detect" => false],
        "3" => ["face_detect" => false, "ai_image_detect" => false]
    ],
    "bio" => "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts" => [
        ["question" => "My ideal weekend", "answer" => "A mix of nature and good food 🍜🌲"],
        ["question" => "The key to my heart is", "answer" => "Honesty and humor."]
    ],
    "metadata" => "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend",
    "image_block" => true
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Trust Score: " . $response['trust_score'];
echo "Image Results: " . json_encode($response['image_results']);
echo "Text Results: " . json_encode($response['text_results']);
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/trust-score"
    
    // Prepare images
    var images []string
    for _, imagePath := range []string{"image1.jpg", "image2.jpg"} {
        imageData, _ := os.ReadFile(imagePath)
        encoded := base64.StdEncoding.EncodeToString(imageData)
        images = append(images, "data:image/jpeg;base64," + encoded)
    }
    
    data := map[string]interface{}{
        "user_id": "abc123",
        "images": images,
        "global_configuration": map[string]bool{
            "face_detect": true,
            "ai_image_detect": false,
        },
        "per_image_configuration": map[string]map[string]bool{
            "0": {"ai_image_detect": false},
            "3": {"face_detect": false, "ai_image_detect": false},
        },
        "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
        "prompts": []map[string]string{
            {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
            {"question": "The key to my heart is", "answer": "Honesty and humor."},
        },
        "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend",
        "image_block": true,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Trust Score: %v\\n", result["trust_score"])
    fmt.Printf("Image Results: %v\\n", result["image_results"])
    fmt.Printf("Text Results: %v\\n", result["text_results"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> trustScoreCheck() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/trust-score';
  
  // Read multiple image files and convert to base64
  final imagePaths = ['image1.jpg', 'image2.jpg'];
  final List<String> images = [];
  
  for (final imagePath in imagePaths) {
    final imageFile = File(imagePath);
    final imageBytes = await imageFile.readAsBytes();
    final base64Image = base64Encode(imageBytes);
    images.add('data:image/jpeg;base64,$base64Image');
  }
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'user_id': 'abc123',
      'images': images,
      'global_configuration': {'face_detect': true, 'ai_image_detect': false},
      'per_image_configuration': {
        '0': {'ai_image_detect': false},
        '3': {'face_detect': false, 'ai_image_detect': false}
      },
      'bio': 'Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.',
      'prompts': [
        {'question': 'My ideal weekend', 'answer': 'A mix of nature and good food 🍜🌲'},
        {'question': 'The key to my heart is', 'answer': 'Honesty and humor.'}
      ],
      'metadata': 'IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend',
      'image_block': true,
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Trust Score: \${result['trust_score']}');
    print('Image Results: \${result['image_results']}');
    print('Text Results: \${result['text_results']}');
  }
}`
  },
  'text-analysis': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/text-analysis', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    // Bio (optional)
    bio: "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",

    // Prompts (optional)
    prompts: [
      {
        question: "My ideal weekend",
        answer: "A mix of nature and good food 🍜🌲"
      },
      {
        question: "The key to my heart is",
        answer: "Honesty and humor."
      }
    ],

    // Metadata (optional)
    metadata: \`
      IP=192.168.0.3
      device=Android
      region=CA
      num_photos=2
      referred_by=friend
    \`
  })
});

const result = await response.json();
// Score: result.score (0-100)`,
    python: `import requests

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/text-analysis"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

data = {
    # Optional: Bio
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    # Optional: Prompts
    "prompts": [
        {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
        {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    # Optional: Metadata
    "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend"
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Score: {result['score']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/text-analysis \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts": [
      {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
      {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend"
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/text-analysis";

$data = [
    "bio" => "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts" => [
        ["question" => "My ideal weekend", "answer" => "A mix of nature and good food 🍜🌲"],
        ["question" => "The key to my heart is", "answer" => "Honesty and humor."]
    ],
    "metadata" => "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend"
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Score: " . $response['score'];
?>`,
    go: `package main

import (
    "bytes"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/text-analysis"
    
    data := map[string]interface{}{
        "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
        "prompts": []map[string]string{
            {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
            {"question": "The key to my heart is", "answer": "Honesty and humor."},
        },
        "metadata": "IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend",
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Score: %v\\n", result["score"])
}`,
    dart: `import 'dart:convert';
import 'package:http/http.dart' as http;

Future<void> textAnalysisCheck() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/text-analysis';
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'bio': 'Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.',
      'prompts': [
        {'question': 'My ideal weekend', 'answer': 'A mix of nature and good food 🍜🌲'},
        {'question': 'The key to my heart is', 'answer': 'Honesty and humor.'}
      ],
      'metadata': 'IP=192.168.0.3\\ndevice=Android\\nregion=CA\\nnum_photos=2\\nreferred_by=friend',
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Score: \${result['score']}');
  }
}`
  },
  'face-verify': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/face-verify', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    selfie: 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
    profile_images: [
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
    ],
    similarity_threshold: 90
  })
});

const result = await response.json();
// Verified: result.verified
// Matches: result.matches
// Best match: result.best_match`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/face-verify"

headers = {
    "Authorization": f"Bearer {api_key}",
    "Content-Type": "application/json"
}

# Read selfie image
with open("selfie.jpg", "rb") as selfie_file:
    selfie_data = base64.b64encode(selfie_file.read()).decode('utf-8')

# Read profile images
profile_images = []
for image_path in ["profile1.jpg", "profile2.jpg"]:
    with open(image_path, "rb") as image_file:
        image_data = base64.b64encode(image_file.read()).decode('utf-8')
        profile_images.append(f"data:image/jpeg;base64,{image_data}")

data = {
    "selfie": f"data:image/jpeg;base64,{selfie_data}",
    "profile_images": profile_images,
    "similarity_threshold": 90
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Verified: {result['verified']}")
print(f"Matches: {result['matches']}")
print(f"Best match: {result['best_match']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/face-verify \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "selfie": "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
    "profile_images": [
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
    ],
    "similarity_threshold": 90
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/face-verify";

// Read selfie image
$selfieData = base64_encode(file_get_contents("selfie.jpg"));

// Read profile images
$profileImages = [];
foreach (["profile1.jpg", "profile2.jpg"] as $imagePath) {
    $imageData = base64_encode(file_get_contents($imagePath));
    $profileImages[] = "data:image/jpeg;base64," . $imageData;
}

$data = [
    "selfie" => "data:image/jpeg;base64," . $selfieData,
    "profile_images" => $profileImages,
    "similarity_threshold" => 90
];

$options = [
    "http" => [
        "header" => [
            "Authorization: Bearer " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Verified: " . ($response['verified'] ? 'true' : 'false');
echo "Matches: " . json_encode($response['matches']);
echo "Best match: " . json_encode($response['best_match']);
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/face-verify"
    
    // Read selfie image
    selfieData, _ := os.ReadFile("selfie.jpg")
    selfieEncoded := base64.StdEncoding.EncodeToString(selfieData)
    
    // Read profile images
    var profileImages []string
    for _, imagePath := range []string{"profile1.jpg", "profile2.jpg"} {
        imageData, _ := os.ReadFile(imagePath)
        encoded := base64.StdEncoding.EncodeToString(imageData)
        profileImages = append(profileImages, "data:image/jpeg;base64," + encoded)
    }
    
    data := map[string]interface{}{
        "selfie": "data:image/jpeg;base64," + selfieEncoded,
        "profile_images": profileImages,
        "similarity_threshold": 90,
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("Authorization", "Bearer " + apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Verified: %v\\n", result["verified"])
    fmt.Printf("Matches: %v\\n", result["matches"])
    fmt.Printf("Best match: %v\\n", result["best_match"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> faceVerify() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/face-verify';
  
  // Read selfie image
  final selfieFile = File('selfie.jpg');
  final selfieBytes = await selfieFile.readAsBytes();
  final base64Selfie = base64Encode(selfieBytes);
  
  // Read profile images
  final profilePaths = ['profile1.jpg', 'profile2.jpg'];
  final List<String> profileImages = [];
  
  for (final imagePath in profilePaths) {
    final imageFile = File(imagePath);
    final imageBytes = await imageFile.readAsBytes();
    final base64Image = base64Encode(imageBytes);
    profileImages.add('data:image/jpeg;base64,$base64Image');
  }
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'Authorization': 'Bearer $apiKey',
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'selfie': 'data:image/jpeg;base64,$base64Selfie',
      'profile_images': profileImages,
      'similarity_threshold': 90,
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Verified: \${result['verified']}');
    print('Matches: \${result['matches']}');
    print('Best match: \${result['best_match']}');
  }
}`
  },
  'moderation-submit-profile': {
    javascript: `const response = await fetch('https://api.novembr.dev/api/moderation/submit-profile', {
  method: 'POST',
  headers: {
    'X-API-Key': 'YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    user_id: 'abc123',

    // 1️⃣ Images (required)
    images: [
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...',
      'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...'
    ],

    // Optional: Bio
    bio: "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",

    // Optional: Prompts
    prompts: [
      {
        question: "My ideal weekend",
        answer: "A mix of nature and good food 🍜🌲"
      },
      {
        question: "The key to my heart is",
        answer: "Honesty and humor."
      }
    ],

    // Optional: Metadata
    metadata: {
      IP: "192.168.0.3",
      device: "Android",
      region: "CA",
      num_photos: 2,
      referred_by: "friend"
    }
  })
});

const result = await response.json();
// Profile ID: result.profile_id
// Status: result.status (approved, rejected, pending)
// Trust Score: result.trust_score`,
    python: `import requests
import base64

api_key = "YOUR_API_KEY"
url = "https://api.novembr.dev/api/moderation/submit-profile"

headers = {
    "X-API-Key": api_key,
    "Content-Type": "application/json"
}

# Prepare images
images = []
for image_path in ["image1.jpg", "image2.jpg"]:
    with open(image_path, "rb") as image_file:
        image_data = base64.b64encode(image_file.read()).decode('utf-8')
        images.append(f"data:image/jpeg;base64,{image_data}")

data = {
    "user_id": "abc123",
    "images": images,
    # Optional: Bio
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    # Optional: Prompts
    "prompts": [
        {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
        {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    # Optional: Metadata
    "metadata": {
        "IP": "192.168.0.3",
        "device": "Android",
        "region": "CA",
        "num_photos": 2,
        "referred_by": "friend"
    }
}

response = requests.post(url, headers=headers, json=data)
result = response.json()
print(f"Profile ID: {result['profile_id']}")
print(f"Status: {result['status']}")
print(f"Trust Score: {result['trust_score']}")`,
    curl: `curl -X POST https://api.novembr.dev/api/moderation/submit-profile \\
  -H "X-API-Key: YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "user_id": "abc123",
    "images": [
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ...",
      "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQ..."
    ],
    "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts": [
      {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
      {"question": "The key to my heart is", "answer": "Honesty and humor."}
    ],
    "metadata": {
      "IP": "192.168.0.3",
      "device": "Android",
      "region": "CA",
      "num_photos": 2,
      "referred_by": "friend"
    }
  }'`,
    php: `<?php
$apiKey = "YOUR_API_KEY";
$url = "https://api.novembr.dev/api/moderation/submit-profile";

// Prepare images
$images = [];
foreach (["image1.jpg", "image2.jpg"] as $imagePath) {
    $imageData = base64_encode(file_get_contents($imagePath));
    $images[] = "data:image/jpeg;base64," . $imageData;
}

$data = [
    "user_id" => "abc123",
    "images" => $images,
    "bio" => "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
    "prompts" => [
        ["question" => "My ideal weekend", "answer" => "A mix of nature and good food 🍜🌲"],
        ["question" => "The key to my heart is", "answer" => "Honesty and humor."]
    ],
    "metadata" => [
        "IP" => "192.168.0.3",
        "device" => "Android",
        "region" => "CA",
        "num_photos" => 2,
        "referred_by" => "friend"
    ]
];

$options = [
    "http" => [
        "header" => [
            "X-API-Key: " . $apiKey,
            "Content-Type: application/json"
        ],
        "method" => "POST",
        "content" => json_encode($data)
    ]
];

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
$response = json_decode($result, true);

echo "Profile ID: " . $response['profile_id'];
echo "Status: " . $response['status'];
echo "Trust Score: " . $response['trust_score'];
?>`,
    go: `package main

import (
    "bytes"
    "encoding/base64"
    "encoding/json"
    "fmt"
    "io"
    "net/http"
    "os"
)

func main() {
    apiKey := "YOUR_API_KEY"
    url := "https://api.novembr.dev/api/moderation/submit-profile"
    
    // Prepare images
    var images []string
    for _, imagePath := range []string{"image1.jpg", "image2.jpg"} {
        imageData, _ := os.ReadFile(imagePath)
        encoded := base64.StdEncoding.EncodeToString(imageData)
        images = append(images, "data:image/jpeg;base64," + encoded)
    }
    
    data := map[string]interface{}{
        "user_id": "abc123",
        "images": images,
        "bio": "Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.",
        "prompts": []map[string]string{
            {"question": "My ideal weekend", "answer": "A mix of nature and good food 🍜🌲"},
            {"question": "The key to my heart is", "answer": "Honesty and humor."},
        },
        "metadata": map[string]interface{}{
            "IP": "192.168.0.3",
            "device": "Android",
            "region": "CA",
            "num_photos": 2,
            "referred_by": "friend",
        },
    }
    
    jsonData, _ := json.Marshal(data)
    
    req, _ := http.NewRequest("POST", url, bytes.NewBuffer(jsonData))
    req.Header.Set("X-API-Key", apiKey)
    req.Header.Set("Content-Type", "application/json")
    
    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()
    
    body, _ := io.ReadAll(resp.Body)
    var result map[string]interface{}
    json.Unmarshal(body, &result)
    
    fmt.Printf("Profile ID: %v\\n", result["profile_id"])
    fmt.Printf("Status: %v\\n", result["status"])
    fmt.Printf("Trust Score: %v\\n", result["trust_score"])
}`,
    dart: `import 'dart:convert';
import 'dart:io';
import 'package:http/http.dart' as http;

Future<void> submitProfileForModeration() async {
  const apiKey = 'YOUR_API_KEY';
  const url = 'https://api.novembr.dev/api/moderation/submit-profile';
  
  // Prepare images
  final images = <String>[];
  for (final imagePath in ['image1.jpg', 'image2.jpg']) {
    final imageFile = File(imagePath);
    final imageBytes = await imageFile.readAsBytes();
    final base64Image = base64Encode(imageBytes);
    images.add('data:image/jpeg;base64,$base64Image');
  }
  
  final response = await http.post(
    Uri.parse(url),
    headers: {
      'X-API-Key': apiKey,
      'Content-Type': 'application/json',
    },
    body: jsonEncode({
      'user_id': 'abc123',
      'images': images,
      'bio': 'Coffee addict ☕ | Aspiring chef 👨‍🍳 | Always up for a challenge.',
      'prompts': [
        {'question': 'My ideal weekend', 'answer': 'A mix of nature and good food 🍜🌲'},
        {'question': 'The key to my heart is', 'answer': 'Honesty and humor.'}
      ],
      'metadata': {
        'IP': '192.168.0.3',
        'device': 'Android',
        'region': 'CA',
        'num_photos': 2,
        'referred_by': 'friend'
      }
    }),
  );
  
  if (response.statusCode == 200) {
    final result = jsonDecode(response.body);
    print('Profile ID: \${result['profile_id']}');
    print('Status: \${result['status']}');
    print('Trust Score: \${result['trust_score']}');
  }
}`
  }
};

export const outputExamples = {
  'face-detect': {
    javascript: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`,
    python: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`,
    curl: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`,
    php: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`,
    go: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`,
    dart: `{
  "success": true,
  "faceDetected": true,
  "faceCount": 1,
  "confidence": 98.4,
  "details": [
    {
      "confidence": 98.4,
      "emotions": [
        { "type": "HAPPY", "confidence": 92.1 }
      ],
      "ageRange": { "low": 25, "high": 35 },
      "gender": { "value": "Male", "confidence": 99.0 }
    }
  ],
}`
  },
  'face-detect-batch': {
    javascript: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`,
    python: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`,
    curl: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`,
    php: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`,
    go: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`,
    dart: `{
  "success": true,
  "results": [
    {
      "imageIndex": 0,
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    {
      "imageIndex": 1,
      "success": false,
      "error": "Image too small. Please provide a valid image.",
      "faceDetected": false,
      "faceCount": 0,
      "details": []
    }
  ],
  "totalImages": 2,
  "totalFaces": 1,
  "processingTimeMs": 123,
}`
  },
  'ai-image-detect': {
    javascript: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`,
    python: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`,
    curl: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`,
    php: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`,
    go: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`,
    dart: `{
  "success": true,
  "aiGenerated": false,
  "aiGeneratedScore": 0.18,
  "confidence": 18,
  "details": {
    "rawScore": 0.18,
    "threshold": 0.5
  },
}`
  },
  'composite-check': {
    javascript: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`,
    python: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`,
    curl: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`,
    php: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`,
    go: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`,
    dart: `{
  "success": true,
  "results": {
    "face_detect": {
      "success": true,
      "faceDetected": true,
      "faceCount": 1,
      "confidence": 98.4,
      "details": [
        {
          "confidence": 98.4,
          "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
          "ageRange": { "low": 25, "high": 35 },
          "gender": { "value": "Male", "confidence": 99.0 }
        }
      ]
    },
    "ai_image_detect": {
      "success": true,
      "aiGenerated": false,
      "aiGeneratedScore": 0.18,
      "confidence": 18,
      "details": {
        "rawScore": 0.18,
        "threshold": 0.5
      }
    }
  },
  "options": { "face_detect": true, "ai_image_detect": true },
}`
  },
  'trust-score': {
    javascript: `{
  "success": true,
  "trust_score": 85,
  "image_results": [
    {
      "imageIndex": 0,
      "success": true,
      "passed": true,
      "failedChecks": [],
      "face_detect": {
        "success": true,
        "faceDetected": true,
        "faceCount": 1,
        "confidence": 98.4,
        "details": [
          {
            "confidence": 98.4,
            "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
            "ageRange": { "low": 25, "high": 35 },
            "gender": { "value": "Male", "confidence": 99.0 }
          }
        ]
      },
      "ai_image_detect": {
        "success": true,
        "aiGenerated": false,
        "aiGeneratedScore": 0.12,
        "confidence": 12,
        "details": {
          "rawScore": 0.12,
          "threshold": 0.5,
        }
      },
      "error": null
    },
    {
      "imageIndex": 1,
      "success": true,
      "passed": false,
      "failedChecks": ["face_detect"],
      "face_detect": {
        "success": true,
        "faceDetected": false,
        "faceCount": 0,
        "confidence": 0,
        "details": []
      },
      "ai_image_detect": null,
      "error": null
    }
  ],
  "text_results": {
    "score": 90
  },
}`,
    python: `{
  "success": true,
  "trust_score": 85,
  "image_results": [
    {
      "imageIndex": 0,
      "success": true,
      "passed": true,
      "failedChecks": [],
      "face_detect": {
        "success": true,
        "faceDetected": true,
        "faceCount": 1,
        "confidence": 98.4,
        "details": [
          {
            "confidence": 98.4,
            "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
            "ageRange": { "low": 25, "high": 35 },
            "gender": { "value": "Male", "confidence": 99.0 }
          }
        ]
      },
      "ai_image_detect": {
        "success": true,
        "aiGenerated": false,
        "aiGeneratedScore": 0.12,
        "confidence": 12,
        "details": {
          "rawScore": 0.12,
          "threshold": 0.5,
        }
      },
      "error": null
    },
    {
      "imageIndex": 1,
      "success": true,
      "passed": false,
      "failedChecks": ["face_detect"],
      "face_detect": {
        "success": true,
        "faceDetected": false,
        "faceCount": 0,
        "confidence": 0,
        "details": []
      },
      "ai_image_detect": null,
      "error": null
    }
  ],
  "text_results": {
    "score": 90
  },
}`,
    php: `{
  "success": true,
  "trust_score": 85,
  "image_results": [
    {
      "imageIndex": 0,
      "success": true,
      "passed": true,
      "failedChecks": [],
      "face_detect": {
        "success": true,
        "faceDetected": true,
        "faceCount": 1,
        "confidence": 98.4,
        "details": [
          {
            "confidence": 98.4,
            "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
            "ageRange": { "low": 25, "high": 35 },
            "gender": { "value": "Male", "confidence": 99.0 }
          }
        ]
      },
      "ai_image_detect": {
        "success": true,
        "aiGenerated": false,
        "aiGeneratedScore": 0.12,
        "confidence": 12,
        "details": {
          "rawScore": 0.12,
          "threshold": 0.5,
        }
      },
      "error": null
    },
    {
      "imageIndex": 1,
      "success": true,
      "passed": false,
      "failedChecks": ["face_detect"],
      "face_detect": {
        "success": true,
        "faceDetected": false,
        "faceCount": 0,
        "confidence": 0,
        "details": []
      },
      "ai_image_detect": null,
      "error": null
    }
  ],
  "text_results": {
    "score": 90
  },
}`,
    go: `{
  "success": true,
  "trust_score": 85,
  "image_results": [
    {
      "imageIndex": 0,
      "success": true,
      "passed": true,
      "failedChecks": [],
      "face_detect": {
        "success": true,
        "faceDetected": true,
        "faceCount": 1,
        "confidence": 98.4,
        "details": [
          {
            "confidence": 98.4,
            "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
            "ageRange": { "low": 25, "high": 35 },
            "gender": { "value": "Male", "confidence": 99.0 }
          }
        ]
      },
      "ai_image_detect": {
        "success": true,
        "aiGenerated": false,
        "aiGeneratedScore": 0.12,
        "confidence": 12,
        "details": {
          "rawScore": 0.12,
          "threshold": 0.5,
        }
      },
      "error": null
    },
    {
      "imageIndex": 1,
      "success": true,
      "passed": false,
      "failedChecks": ["face_detect"],
      "face_detect": {
        "success": true,
        "faceDetected": false,
        "faceCount": 0,
        "confidence": 0,
        "details": []
      },
      "ai_image_detect": null,
      "error": null
    }
  ],
  "text_results": {
    "score": 90
  },
}`,
    dart: `{
  "success": true,
  "trust_score": 85,
  "image_results": [
    {
      "imageIndex": 0,
      "success": true,
      "passed": true,
      "failedChecks": [],
      "face_detect": {
        "success": true,
        "faceDetected": true,
        "faceCount": 1,
        "confidence": 98.4,
        "details": [
          {
            "confidence": 98.4,
            "emotions": [ { "type": "HAPPY", "confidence": 92.1 } ],
            "ageRange": { "low": 25, "high": 35 },
            "gender": { "value": "Male", "confidence": 99.0 }
          }
        ]
      },
      "ai_image_detect": {
        "success": true,
        "aiGenerated": false,
        "aiGeneratedScore": 0.12,
        "confidence": 12,
        "details": {
          "rawScore": 0.12,
          "threshold": 0.5,
        }
      },
      "error": null
    },
    {
      "imageIndex": 1,
      "success": true,
      "passed": false,
      "failedChecks": ["face_detect"],
      "face_detect": {
        "success": true,
        "faceDetected": false,
        "faceCount": 0,
        "confidence": 0,
        "details": []
      },
      "ai_image_detect": null,
      "error": null
    }
  ],
  "text_results": {
    "score": 90
  },
}`
  },
  'text-analysis': {
    javascript: `{
  "success": true,
  "score": 85,
}`,
    python: `{
  "success": true,
  "score": 85,
}`,
    curl: `{
  "success": true,
  "score": 85,
}`,
    php: `{
  "success": true,
  "score": 85,
}`,
    go: `{
  "success": true,
  "score": 85,
}`,
    dart: `{
  "success": true,
  "score": 85,
}`
  },
  'face-verify': {
    javascript: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`,
    python: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`,
    curl: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`,
    php: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`,
    go: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`,
    dart: `{
  "success": true,
  "verified": true,
  "matches": [
    {
      "profile_index": 0,
      "similarity": 95.5,
      "confidence": 99.2
    }
  ],
  "best_match": {
    "profile_index": 0,
    "similarity": 95.5,
    "confidence": 99.2
  },
  "similarity_threshold": 90,
}`
  },
  'moderation-submit-profile': {
    javascript: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`,
    python: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`,
    curl: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`,
    php: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`,
    go: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`,
    dart: `{
  "success": true,
  "profile_id": "550e8400-e29b-41d4-a716-446655440000",
  "status": "approved",
  "trust_score": 85,
  "message": "Profile submitted successfully"
}`
  }
};
